"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
var apiUrls_1 = __importDefault(require("../../youwell-common/apiUrls"));
var ReduxStoreHelper_1 = __importDefault(require("../../youwell-common/ReduxStoreHelper"));
var dateUtils_1 = require("../../youwell-common/dateUtils");
var arrayUtils_1 = require("../../youwell-common/arrayUtils");
var actions_1 = require("./actions");
var constants_1 = require("../../common/constants");
var responseUtils_1 = require("../../youwell-common/responseUtils");
var constants_2 = require("../../youwell-common/constants");
var TASKVISITED = 'TASKVISITED';
var FAVOURITE_INSERTED = 'FAVOURITE_INSERTED';
var PATIENTELEMENT_INSERTED = 'PATIENTELEMENT_INSERTED';
var PATIENTELEMENT_UPDATED = 'PATIENTELEMENT_UPDATED';
var PATIENTELEMENT_DELETED = 'PATIENTELEMENT_DELETED';
var RESPONSE_FORMS_RECEIVED = 'RESPONSE_FORMS_RECEIVED';
var RESET_RESPONSE_FORM = 'RESET_RESPONSE_FORM';
var UPDATE_SUBMITTED_FORMS = 'UPDATE_SUBMITTED_FORMS';
var storeHelper = new ReduxStoreHelper_1.default(actions_1.PROGRAM_ACTION_PREFIX);
exports.actionCreators = __assign(__assign({}, storeHelper.defaultActionCreators(apiUrls_1.default.app.program)), { getCurrentProgram: storeHelper.createGetListActionCreator("".concat(apiUrls_1.default.app.program, "/current"), actions_1.CURRENTPROGRAM_RECEIVED), updateResponse: function (patientProgramTaskResponse) { return function (dispatch) {
        dispatch({ type: "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(actions_1.TASKRESPONSE_INSERTED), data: patientProgramTaskResponse });
    }; }, saveResponse: function (patientProgramTaskResponse, options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.program, "/resp"),
            method: 'POST',
            body: patientProgramTaskResponse,
            completeAction: "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(TASKVISITED),
            options: options,
        });
    }; }, visitTask: function (taskInfo, options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.program, "/vt"),
            method: 'POST',
            body: taskInfo,
            completeAction: "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(TASKVISITED),
            options: __assign({ background: true }, options),
        });
    }; }, toggleFavourite: function (favTask, options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.program, "/fav"),
            method: 'POST',
            body: favTask,
            completeAction: "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(FAVOURITE_INSERTED),
            options: options,
        });
    }; }, insertPatientElement: storeHelper.createInsertActionCreator("".concat(apiUrls_1.default.app.program, "/task"), PATIENTELEMENT_INSERTED), updatePatientElement: storeHelper.createUpdateActionCreator("".concat(apiUrls_1.default.app.program, "/task"), PATIENTELEMENT_UPDATED), deletePatientElement: storeHelper.createDeleteActionCreator("".concat(apiUrls_1.default.app.program, "/task"), PATIENTELEMENT_DELETED), getProgramResponses: storeHelper.createGetElementActionCreator("".concat(apiUrls_1.default.app.program, "/resp"), actions_1.RESPONSES_RECEIVED), getResponseForms: storeHelper.createGetListActionCreator("".concat(apiUrls_1.default.app.program, "/forms"), RESPONSE_FORMS_RECEIVED), setCurrentForm: function (patientProgramElementId, taskId, form) { return function (dispatch) {
        dispatch({ type: "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(RESET_RESPONSE_FORM), data: { patientProgramElementId: patientProgramElementId, taskId: taskId, form: form } });
    }; }, updateAllFormsList: function (patientProgramElementId, taskId, form) { return function (dispatch) {
        dispatch({ type: "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(UPDATE_SUBMITTED_FORMS), data: { patientProgramElementId: patientProgramElementId, taskId: taskId, form: form } });
    }; } });
var initialState = __assign(__assign({}, storeHelper.defaultInitialState), { currentProgram: null, currentProgramTaskResponses: null, allForms: null });
var buildElementViewModel = function (element, allPrevElementsCompleted) {
    var _a, _b;
    var isEnded = Boolean(element.endTime && ((0, dateUtils_1.getLocalDate)(element.endTime) || 0) < (0, dateUtils_1.today)());
    var isNotStarted = Boolean(element.startTime && ((0, dateUtils_1.getLocalDate)(element.startTime) || 0) > new Date());
    var prereqNotCompleted = element.completeInOrder && !allPrevElementsCompleted;
    var progress = (element.totalTasks || 0) > 0 ? Math.min((element.totalTasksCompleted || 0) / (element.totalTasks || 1), 1) : 0;
    var name = element.displayName || ((_a = element.module) === null || _a === void 0 ? void 0 : _a.name) || ((_b = element.task) === null || _b === void 0 ? void 0 : _b.name) || '';
    return __assign(__assign({}, element), { progress: progress, name: name, isEnded: isEnded, isNotStarted: isNotStarted, prereqNotCompleted: prereqNotCompleted, disabled: isEnded || isNotStarted || prereqNotCompleted });
};
var buildProgramViewModel = function (programData) {
    var _a, _b;
    if (!programData) {
        return null;
    }
    // finds first element of each type that is not completed. Used for disabling elements with "CompleteInOrder" set.
    var firstIncompleteIndex = (_a = programData.elements) === null || _a === void 0 ? void 0 : _a.reduce(function (prev, curr, i) {
        var _a;
        return (__assign(__assign({}, prev), (_a = {}, _a[curr.elementGroup] = prev[curr.elementGroup] !== undefined || curr.completed ? prev[curr.elementGroup] : i, _a)));
    }, {});
    var elementVms = (_b = programData.elements) === null || _b === void 0 ? void 0 : _b.map(function (d, i) { return buildElementViewModel(d, firstIncompleteIndex[d.elementGroup] >= i); });
    var groupedElements = elementVms === null || elementVms === void 0 ? void 0 : elementVms.reduce(function (prev, curr) {
        var _a;
        var _b;
        return (!curr ? prev : __assign(__assign({}, prev), (_a = {}, _a[curr.elementGroup] = __spreadArray(__spreadArray([], prev[curr.elementGroup] || [], true), [
            __assign(__assign({}, curr), { indexInGroup: ((_b = prev[curr.elementGroup]) === null || _b === void 0 ? void 0 : _b.length) || 0 }),
        ], false), _a)));
    }, Object.keys(constants_1.patientProgramElementGroups).reduce(function (prev, curr) {
        var _a;
        return (__assign(__assign({}, prev), (_a = {}, _a[constants_1.patientProgramElementGroups[curr]] = [], _a)));
    }, {}));
    return __assign(__assign({}, programData), { isActiveProgram: programData.status === constants_2.patientProgramStatus.active, elements: elementVms, favourites: (0, arrayUtils_1.toBoolLookup)(programData.favouriteTasks, 'taskId'), groupedElements: groupedElements, totalModules: groupedElements[constants_1.patientProgramElementGroups.main].length, completedModules: groupedElements[constants_1.patientProgramElementGroups.main].reduce(function (prev, curr) { return prev + (curr.completed ? 1 : 0); }, 0), scheduledElements: groupedElements[constants_1.patientProgramElementGroups.scheduled], appElements: groupedElements[constants_1.patientProgramElementGroups.app], unAnsweredConsentIndex: groupedElements[constants_1.patientProgramElementGroups.consent].reduce(function (prev, curr, i) { return (prev > -1 || curr.completed || curr.disabled ? prev : i); }, -1) });
};
var currentProgramWithVisitResponse = function (currentProgram, visitTaskResponse) { return (__assign(__assign({}, currentProgram), { elements: currentProgram.elements.map(function (e) { return (e.id === visitTaskResponse.patientProgramElementId ? __assign(__assign({}, e), { task: e.task ? __assign(__assign({}, e.task), { visited: true }) : null, module: e.module ? __assign(__assign({}, e.module), { tasks: e.module.tasks.map(function (t) { return (t.id === visitTaskResponse.taskId ? __assign(__assign({}, t), { visited: true, completed: visitTaskResponse.taskCompleted }) : t); }) }) : null, completed: visitTaskResponse.elementCompleted, totalTasksCompleted: visitTaskResponse.completedTasks, totalTasksVisited: visitTaskResponse.visitedTasks }) : e); }) })); };
var reducer = function (state, action) {
    var _a, _b, _c, _d, _e, _f;
    var _g, _h, _j, _k, _l, _m, _o, _p, _q;
    switch (action.type) {
        case "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(TASKVISITED): {
            var _r = action, inputData = _r.inputData, data = _r.data;
            if (!state.currentProgram || state.currentProgram.id !== (data === null || data === void 0 ? void 0 : data.patientProgramId)) {
                return state;
            }
            var vm = buildProgramViewModel(currentProgramWithVisitResponse(state.currentProgram, data));
            var currentProgramTaskResponses = (0, responseUtils_1.parseResponseSaveResult)(inputData, data, state.currentProgramTaskResponses);
            return __assign(__assign({}, state), { currentProgram: vm, currentProgramTaskResponses: currentProgramTaskResponses });
        }
        case "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(actions_1.TASKRESPONSE_INSERTED): {
            if (!state.currentProgram) {
                return state;
            }
            var data_1 = action.data;
            var taskSubtotals = ((_k = (_j = (_h = (_g = state.currentProgram
                .elements.find(function (element) { return element.id === data_1.patientProgramElementId; })) === null || _g === void 0 ? void 0 : _g.module) === null || _h === void 0 ? void 0 : _h.tasks) === null || _j === void 0 ? void 0 : _j.find(function (task) { return task.id === data_1.taskId; })) === null || _k === void 0 ? void 0 : _k.taskSubtotals) || [];
            var currentProgramTaskResponses = (0, responseUtils_1.parseInsertedResponse)(data_1, taskSubtotals, state.currentProgramTaskResponses);
            return __assign(__assign({}, state), { currentProgramTaskResponses: currentProgramTaskResponses });
        }
        case "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(actions_1.RESPONSES_RECEIVED): {
            if (!state.currentProgram || state.currentProgram.id !== action.reducerParams.patientProgramId) {
                return state;
            }
            var data = action.data;
            return __assign(__assign({}, state), { currentProgramTaskResponses: (0, responseUtils_1.buildResponseLookup)(data, state.currentProgramTaskResponses) });
        }
        case "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(actions_1.CURRENTPROGRAM_RECEIVED): {
            var data = action.data;
            var vm = buildProgramViewModel(data);
            return __assign(__assign({}, state), { currentProgram: vm });
        }
        case actions_1.AUTH_SUCCESS_LOGIN: {
            var data = action.data;
            if (!data.currentProgram) {
                return state;
            }
            var vm = buildProgramViewModel(data.currentProgram);
            return __assign(__assign({}, state), { currentProgram: vm });
        }
        case "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(FAVOURITE_INSERTED): {
            if (!state.currentProgram || state.currentProgram.id !== action.reducerParams.patientProgramId) {
                return state;
            }
            var data = action.data;
            var vm = buildProgramViewModel(__assign(__assign({}, state.currentProgram), { favouriteTasks: data }));
            return __assign(__assign({}, state), { currentProgram: vm });
        }
        case "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(PATIENTELEMENT_INSERTED): {
            if (!state.currentProgram || state.currentProgram.id !== action.reducerParams.patientProgramId || !action.data) {
                return state;
            }
            var data = action.data;
            var vm = buildProgramViewModel(__assign(__assign({}, state.currentProgram), { elements: state.currentProgram.elements ? __spreadArray(__spreadArray([], state.currentProgram.elements, true), [data.patientProgramElement], false) : [data.patientProgramElement] }));
            return __assign(__assign({}, state), { currentProgram: vm });
        }
        case "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(PATIENTELEMENT_UPDATED): {
            if (!state.currentProgram || state.currentProgram.id !== action.reducerParams.patientProgramId) {
                return state;
            }
            var data_2 = action.data;
            var vm = buildProgramViewModel(__assign(__assign({}, state.currentProgram), { elements: state.currentProgram.elements.map(function (d) { return (d.id === data_2.id ? data_2 : d); }) }));
            return __assign(__assign({}, state), { currentProgram: vm });
        }
        case "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(PATIENTELEMENT_DELETED): {
            if (!state.currentProgram || state.currentProgram.id !== action.reducerParams.patientProgramId) {
                return state;
            }
            var data_3 = action.data;
            var vm = buildProgramViewModel(__assign(__assign({}, state.currentProgram), { elements: state.currentProgram.elements.filter(function (d) { return d.id !== data_3.id; }) }));
            return __assign(__assign({}, state), { currentProgram: vm });
        }
        case "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(RESPONSE_FORMS_RECEIVED): {
            var _s = action, data = _s.data, requestParams = _s.requestParams;
            return __assign(__assign({}, state), { allForms: __assign(__assign({}, state.allForms), (_a = {}, _a[requestParams.patientProgramElementId] = __assign(__assign({}, (_l = state.allForms) === null || _l === void 0 ? void 0 : _l[requestParams.patientProgramElementId]), (_b = {}, _b[requestParams.taskId] = data.map(responseUtils_1.buildResponseFormVm), _b)), _a)) });
        }
        case "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(UPDATE_SUBMITTED_FORMS): {
            var data_4 = action.data;
            var existingForms = ((_o = (_m = state.allForms) === null || _m === void 0 ? void 0 : _m[data_4.patientProgramElementId]) === null || _o === void 0 ? void 0 : _o[data_4.taskId]) || [];
            var hasExistingForm = existingForms.some(function (d) { var _a; return d.formId === ((_a = data_4.form) === null || _a === void 0 ? void 0 : _a.formId); });
            var formsForTask = void 0;
            if (hasExistingForm) {
                formsForTask = existingForms.map(function (d) { var _a; return (d.formId === ((_a = data_4.form) === null || _a === void 0 ? void 0 : _a.formId) ? data_4.form : d); });
            }
            else {
                formsForTask = __spreadArray([data_4.form], existingForms, true);
            }
            return __assign(__assign({}, state), { allForms: __assign(__assign({}, state.allForms), (_c = {}, _c[data_4.patientProgramElementId] = __assign(__assign({}, (_p = state.allForms) === null || _p === void 0 ? void 0 : _p[data_4.patientProgramElementId]), (_d = {}, _d[data_4.taskId] = formsForTask, _d)), _c)) });
        }
        case "".concat(actions_1.PROGRAM_ACTION_PREFIX, "/").concat(RESET_RESPONSE_FORM): {
            var data = action.data;
            if (!((_q = state.currentProgramTaskResponses) === null || _q === void 0 ? void 0 : _q[data.patientProgramElementId])) {
                return state;
            }
            return __assign(__assign({}, state), { currentProgramTaskResponses: __assign(__assign({}, state.currentProgramTaskResponses), (_e = {}, _e[data.patientProgramElementId] = __assign(__assign({}, state.currentProgramTaskResponses[data.patientProgramElementId]), (_f = {}, _f[data.taskId] = data.form, _f)), _e)) });
        }
        default: {
            var stateFromDefaultActions = storeHelper.defaultReducer(state, action, initialState);
            if (stateFromDefaultActions !== null) {
                return stateFromDefaultActions;
            }
            return state || initialState;
        }
    }
};
exports.reducer = reducer;
